export enum OAuth {
  ACCESS_TOKEN = 'access_token',
  AT_EXPIRES = 'at_expires',
  EXPIRES_IN = 'expires_in',
  AT_ISSUED_AT = 'at_issued_at',
  ISSUED_AT = 'issued_at',
  REFRESH_TOKEN = 'refresh_token',
  RT_EXPIRES_IN = 'refresh_token_expires_in',
  RT_ISSUED_AT = 'rt_issued_at',
  EMAIL = 'email',
  NAME = 'name',
  USERNAME = 'username'
}